<template>
  <div class="x-tablelist-view product-list" data-automation="manageProduct">
    <!-- 搜索行 -->
    <!-- <my-search-option
      class="product-list-option"
      :layout="layout"
      :data="filter"
      :isBreak="true"
      @search="seach"
      @clear="clear"
    ></my-search-option>

    <div class="product-list-center">
      <ux-button v-if="this.$hasModule(20)" type="primary" icon="ux_icon_plus" @click="showAdd">
        {{ $t('HT.add') }}</ux-button
      >
      <span class="product-list-total">{{
        $t('HT.orderOverview.total', { total: tableData.totalSize })
      }}</span>
    </div> -->
    <ux-searchOption
      :layout="layout"
      :data="filter"
      @change="change"
      @search="seach"
      @add="showAdd"
      @resetsearch="clear"
    ></ux-searchOption>

    <!-- 表格 -->
    <div class="x-table-box">
      <ux-table
        class="product-list-table"
        layout="total, sizes, prev, pager, next"
        :emptyText="$t('HT.nodata')"
        :hide-on-single-page="true"
        :data="tableData.list"
        :total="tableData.totalSize"
        :columns="columns"
        :size.sync="filter.size"
        :page.sync="filter.page"
        @changePage="changePage"
        @changeSize="changeSize"
      ></ux-table>
    </div>
  </div>
</template>

<script>
import mySearchOption from '@c/mySearchOption/mySearchOption';
import addProduct from './template/addProduct';
export default {
  components: {
    addProduct,
    mySearchOption
  },
  data() {
    return {
      // 是否显示分页
      showPage: true,
      layout: [
        // 搜索项配置
        {
          type: 'select',
          width: '200px',
          options: [],
          key: 'typeId',
          placeholder: this.$t('HT.productAll.type'),
          event: 'change',
          props: {
            label: 'name',
            value: 'id'
          }
        },
        {
          label: this.$t('HT.unbindApi.name'),
          width: '272px',
          type: 'input',
          key: 'name',
          hideBtn: true,
          placeholder: this.$t('HT.rules.addProduct.name')
        },
        {
          type: 'button',
          text: this.$t('HT.search'),
          event: 'search',
          spacing: '20px'
        },
        {
          type: 'button',
          text: this.$t('HT.reset'),
          plain: true,
          event: 'resetsearch'
        },
        {
          type: 'button',
          text: this.$t('HT.add'),
          icon: 'ux_icon_plus',
          hidden: !this.$hasModule(20),
          right: true,
          event: 'add'
        },
      ],
      columns: [
        // 表头数据
        {
          label: this.$t('HT.unbindApi.name'),
          tooltip: true,
          align: 'left',
          prop: 'name'
        },
        {
          label: this.$t('HT.productAll.type'),
          prop: 'type',
          align: 'left',
          tooltip: true
        },
        {
          label: this.$t('HT.apiStepOne.remark'),
          prop: 'remark',
          align: 'left',
          tooltip: true
        },
        {
          label: this.$t('HT.orderManage.status'),
          prop: 'published',
          align: 'left',
          tooltip: true,
          formatter: (row, column, cellValue) => {
            return this.$opt.switchStr(cellValue, this.$opt.productStatus);
          }
        },
        {
          label: this.$t('HT.createdTime'),
          prop: 'created_date',
          align: 'left',
          tooltip: true
        },

        {
          label: this.$t('HT.operation'),
          align: 'left',
          hidden: !this.$hasModule(20),
          width: 250,
          render: (h, params) => {
            return h('div', {
              attrs: {
                style: 'overflow:'
              },
            }, [
              h(
                'ux-button',
                {
                  props: {
                    type: 'primary',
                    text: true
                  },
                  attrs: {
                    style: 'margin-right: 10px'
                  },
                  on: {
                    click: () => {
                      this.$router.push({
                        name: 'productInfo',
                        query: {
                          id: params.id,
                          tab: 0
                        }
                      });
                    }
                  }
                },
                this.$t('HT.productAll.pricing')
              ),
              h(
                'ux-button',
                {
                  props: {
                    type: 'primary',
                    text: true
                  },
                  attrs: {
                    style: 'margin-right: 10px'
                  },
                  on: {
                    click: () => {
                      this.$router.push({
                        name: 'productInfo',
                        query: {
                          id: params.id,
                          tab: 1
                        }
                      });
                    }
                  }
                },
                this.$t('HT.manage')
              ),
              h('moreDropdown', {
                props: {
                  list: [{
                    label: this.$t('HT.soldIn'),
                    disabled: params.published == 1 || params.published == 2,
                    event: 'startUp'
                  }, {
                    label: this.$t('HT.soldOut'),
                    disabled: params.published == 0,
                    event: 'endDown'
                  }, {
                    label: this.$t('HT.delete'),
                    divided: true,
                    event: 'delete'
                  }],
                  text: this.$t('HT.more')
                },
                on: {
                  clickItem: (method) => {
                    console.log('method', method);
                    method && this[method](params);
                  }
                }
              })
              // h(
              //   'ux-button',
              //   {
              //     props: {
              //       type: 'primary',
              //       text: true,
              //       disabled: params.published == 1 || params.published == 2
              //     },
              //     attrs: {
              //       style: 'margin-right: 10px'
              //     },
              //     on: {
              //       click: () => {
              //         this.startUp(params);
              //       }
              //     }
              //   },
              //   this.$t('HT.soldIn')
              // ),
              // h(
              //   'ux-button',
              //   {
              //     props: {
              //       type: params.published == 0 ? 'primary' : 'danger',
              //       text: true,
              //       disabled: params.published == 0
              //     },
              //     attrs: {
              //       style: 'margin-right: 10px'
              //     },
              //     on: {
              //       click: () => {
              //         this.endDown(params);
              //       }
              //     }
              //   },
              //   this.$t('HT.soldOut')
              // ),
              // h(
              //   'ux-button',
              //   {
              //     props: {
              //       type: 'danger',
              //       text: true
              //     },
              //     on: {
              //       click: () => {
              //         this.delete(params);
              //       }
              //     }
              //   },
              //   this.$t('HT.delete')
              // )
            ]);
          }
        }
      ],
      filter: {
        // 查询参数
        name: '', // 应用名称
        state: '', // 状态
        createdTime: [], // 创建时间
        page: 1,
        size: 10
      },
      tableData: {
        // 表格数据
        totalSize: 0,
        list: []
      }
    };
  },
  created() {
    this.getList(this.filter);
    this.getProductTypes();
  },
  mounted() {
    // document.querySelector('.product-list-table .ux-pagination').classList.remove('is-background');
  },

  methods: {
    /**
     * 改变产品类型
     */
    change() {
      this.filter.page = 1;
      this.getList(this.filter);
    },
    /**
     * 清除
     */
    clear() {
      this.filter.createdTime = [];
      this.filter.name = '';
      this.filter.state = '';
      this.filter.page = 1;
      this.getList(this.filter);
    },
    /**
     * @description: 管理
     * @param {Object} 一条表数据
     */
    manage(params) {
      this.$router.push({
        name: 'productInfo',
        query: {
          // 对象最好转换一下
          params: JSON.stringify(params)
        }
      });
    },
    /**
     * 获取列表
     * @param {Object} params 请求参数
     */
    getList(params) {
      this.$uxLoading.show();
      this.$api.product.getList(params).then((res) => {
        if (res.code == 10000) {
          this.tableData = {
            totalSize: res.total_size,
            list: res.data
          };
        }
      });
    },

    /**
     * 添加列表
     * @param {Object} params 表单提交参数
     */
    addList(params) {
      this.$uxLoading.show();
      this.$api.product.addList(params).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.addSuccess'));
          this.getList(this.filter);
        }
      });
    },
    /**
     * 上架
     * @param {Object} params 表单参数
     */
    startUp(params) {
      const title = this.$t('HT.productAll.startUp');
      const content = this.$t('HT.productAll.startUp.content');
      this.$uxModal.show({
        title,
        content,
        type: 'warning',
        confirm: () => {
          this.$api.product.userAuditProducts(params.id, { published: 1 }).then((res) => {
            if (res.code == 10000) {
              this.$uxModal.hide();
              this.$uxMessage.success(this.$t('HT.productAll.startUp.success'));
              this.getList(this.filter);
            }
          });
        }
      });
    },

    /**
     * 下架
     * @param {Object} params 表单参数
     */
    endDown(params) {
      const title = this.$t('HT.productAll.endDown');
      const content = this.$t('HT.productAll.endDown.content');
      this.$uxModal.show({
        title,
        content,
        type: 'warning',
        confirm: () => {
          this.$uxLoading.show();
          this.$api.product
            .release(params.id, {
              published: 0
            })
            .then((res) => {
              if (res.code == 10000) {
                this.$uxModal.hide();
                this.$uxMessage.success(this.$t('HT.apiList.soldOutApi.success'));
                this.getList(this.filter);
              }
            });
        }
      });
    },

    /**
     * 删除
     * @param {Object} params 表单参数
     */
    delete(params) {
      if (params.published == false) {
        const title = this.$t('HT.productAll.del');
        const content = this.$t('HT.productAll.del.content');
        this.$uxModal.show({
          title,
          content,
          confirm: () => {
            this.delList(params);
          }
        });
      } else {
        this.$uxModal.hide();
        this.$uxMessage.warning(this.$t('HT.productAll.del.warning'));
      }
    },

    /**
     * 删除列表
     * @param {String} id 唯一标识
     */
    delList(params) {
      this.$uxLoading.show();
      if (params.published == false) {
        this.$api.product.delList(params.id).then((res) => {
          if (res.code == 10000) {
            this.$uxModal.hide();
            this.$uxMessage.success(this.$t('HT.addApi.delSuccess'));
            if (this.tableData.list.length === 1) {
              this.filter.page = this.filter.page - 1 ? this.filter.page - 1 : 1;
            }
            this.getList(this.filter);
          }
        });
      } else {
        this.$uxModal.hide();
        this.$uxMessage.error(this.$t('HT.addApi.delError'));
        this.getList(this.filter);
      }
    },

    /**
     * 新增-弹窗
     */
    showAdd() {
      const title = this.$t('HT.productAll.add');
      this.$uxModal.show({
        title,
        content: (h) => {
          return h(addProduct);
        },
        confirm: (data) => {
          this.addList(data);
        }
      });
    },

    /**
     * 搜索
     */
    seach() {
      this.filter.page = 1;
      this.getList(this.filter);
    },

    /**
     * 改变页容量
     * @param {Number} size 选择的页容量
     */
    changeSize(size) {
      this.filter.size = size;
      this.filter.page = 1;
      this.getList(this.filter);
    },
    /**
     * 改变页码
     * @param {Number} page 选择的页码
     */
    changePage(page) {
      this.filter.page = page;
      this.getList(this.filter);
    },
    getProductTypes() {
      this.$api.product.getAllProductType().then(res => {
        this.layout[0].options = res.data;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.x-tablelist-view.product-list {
  // height: 100%;
  // margin: 0;
  // background: none;
  // border: none;
  // padding: 20px 40px 0 20px;

  .product-list-option {
    padding: 32px 40px 16px;
    margin-bottom: 24px;
    background: #fff;
    border-radius: 8px;
  }

  .product-list-center {
    display: flex;
    align-items: center;
    margin-bottom: 16px;

    .product-list-total {
      color: $color-text-secondary;
      height: 20px;
      line-height: 20px;
      margin-left: 20px;
    }
  }

  ::v-deep .product-list-table .ux-pagination {
    text-align: right;
    padding: 20px 0 32px;

    .btn-next,
    .btn-prev {
      height: 32px;
      background: transparent;
    }

    .el-pager {
      .el-icon-more,
      .number,
      .btn-quicknext:hover {
        height: 32px;
        line-height: 32px;
        background: transparent;
      }
    }

    .el-pagination__sizes .el-select .el-input {
      .el-input__inner {
        border: none;
        background: transparent;
      }
    }

    .el-table .cell {
      overflow: unset;
    }
  }
}
</style>
